// extracted by mini-css-extract-plugin
module.exports = {"alert":"notificationmenuitem_alert__1Ms-p","item":"notificationmenuitem_item__2jy0o"};